import { Component, OnInit,Injector } from "@angular/core";
import { UpdateService } from './core/update-service.component';
import { EnvService } from './core/env.service';
import { Subscription } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import {LocalStorageService} from './core/localstorage-service';
import { AuthService } from './core/auth-service.component';
import { AppService} from './commonservices/app.service';
import { UserService} from './commonservices/user.service';
import { CustomCookieService } from './commonservices/custom-cookie.service';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';

export let browserRefresh = false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./webresolution/webres.scss']
})

export class AppComponent  implements OnInit{ 
  title = 'CT Global Freight Audit';
  closeResult: string;
  public opened = false;
  env: EnvService;
  subscription: Subscription;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;


  public sw: UpdateService;
  constructor(private _injector: Injector, public envi: EnvService,
              private _router: Router,private _localStorage: LocalStorageService,
              private _authService: AuthService,private _appService: AppService,
              private _userService: UserService,
              private _cookieService: CustomCookieService,
              private idle: Idle) {

    this.env = envi;
    if(this.env.production){
      this.sw = <UpdateService>this._injector.get(UpdateService);
      this.sw.checkForUpdates();
    } else{
      this.sw = <UpdateService>this._injector.get(UpdateService);
      this.sw.checkForUpdates();
    }

    if(!browserRefresh){
      this._localStorage.clearAppCached();
    }

    //check on refresh clear the localstorage
    this.subscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
       browserRefresh = !this._router.navigated;
       this._localStorage.clearAppCached();
      }
    });
     
    this.logoutUserInactivity();
  }
  
  ngOnInit(): void {
    if(this.env.production){
      this.sw.updateChanged.subscribe((isupdated)=>{
        this.opened = true;
        setInterval(function(){ window.location.reload(); }, 5000); //reload automaticaly 5 seconds just to display the prompt
      })
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  logoutUserInactivity(){ 
   this.idle.setIdle(this.env.timeoutSesssion);  // sets an idle timeout
   this.idle.setTimeout(5);
   // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
   this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

   this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
   this.idle.onTimeout.subscribe(() => {
     this.idleState = 'Timed out!';
     this.timedOut = true;
     this._cookieService.removeAllCookiesExceptOidc();
     this._authService.logout();
   });
   this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
   this.idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');

   this.idle.watch();
   this.idleState = 'Started.';
   this.timedOut = false;
  }
}
